/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createRecord.defs.js'
export * as $defs from './createRecord.defs.js'
